__turbopack_context__.v({
  "card": "page-module__WuN8JW__card",
  "center": "page-module__WuN8JW__center",
  "code": "page-module__WuN8JW__code",
  "content": "page-module__WuN8JW__content",
  "description": "page-module__WuN8JW__description",
  "grid": "page-module__WuN8JW__grid",
  "logo": "page-module__WuN8JW__logo",
  "main": "page-module__WuN8JW__main",
  "rotate": "page-module__WuN8JW__rotate",
  "vercelLogo": "page-module__WuN8JW__vercelLogo",
});
